function num(v) {
  const n = Number(v);
  return Number.isFinite(n) ? n : 0;
}

export function getGroupMetrics(group, summaries) {
  const pid = String(group.primaryStore?.profileId || group.primaryStore?.storeId || '');
  return summaries?.[pid]?.current || null;
}

/**
 * @param {'name_asc'|'name_desc'|'spend_desc'|'spend_asc'|'sales_desc'|'sales_asc'|'acos_asc'|'acos_desc'|'roas_desc'|'roas_asc'|'region_asc'} sortBy
 */
export function sortStoreGroups(groups, sortBy, summaries = {}) {
  const list = [...(groups || [])];
  const desc = String(sortBy).includes('_desc');
  const key = String(sortBy).replace(/_(asc|desc)$/, '');

  list.sort((a, b) => {
    let cmp = 0;
    if (key === 'name') {
      cmp = a.name.localeCompare(b.name);
    } else if (key === 'region') {
      cmp = String(a.primaryStore?.region || '').localeCompare(String(b.primaryStore?.region || ''));
    } else {
      const ma = getGroupMetrics(a, summaries);
      const mb = getGroupMetrics(b, summaries);
      cmp = num(ma?.[key]) - num(mb?.[key]);
    }
    if (cmp === 0) {
      cmp = a.name.localeCompare(b.name);
    }
    const connectedA = a.primaryStore?.isConnected ? 1 : 0;
    const connectedB = b.primaryStore?.isConnected ? 1 : 0;
    if (cmp === 0 && connectedA !== connectedB) {
      return connectedB - connectedA;
    }
    return desc ? -cmp : cmp;
  });

  return list;
}

export const STORE_LIST_SORT_OPTIONS = [
  { value: 'name_asc', label: 'Name (A–Z)' },
  { value: 'spend_desc', label: 'Spend (high → low)' },
  { value: 'sales_desc', label: 'Sales (high → low)' },
  { value: 'roas_desc', label: 'ROAS (high → low)' },
  { value: 'acos_asc', label: 'ACOS (low → high)' },
  { value: 'region_asc', label: 'Region' },
];
